import * as React from "react";
import { PVPUnitsAmount } from "../pvp/PVPUnitsAmount";
import { MarketXp } from "./MarketXp";
export var MarketFooter = function () {
    return (React.createElement("div", { className: "w100 flex flex--around" },
        React.createElement(MarketXp, null),
        React.createElement(PVPUnitsAmount, null)));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/market/MarketFooter.tsx
// module id = 2847
// module chunks = 3